/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Lightning: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21.8973 9.55964C21.7293 9.21764 21.3813 9.00164 21.0003 9.00164H13.1173L13.9933 1.11164C14.0433 0.665638 13.7893 0.241638 13.3733 0.0736381C12.9563 -0.096362 12.4793 0.0356381 12.2063 0.390638L2.2063 13.3906C1.9743 13.6926 1.9333 14.1006 2.1023 14.4426C2.2713 14.7856 2.6193 15.0016 3.0003 15.0016H10.8833L10.0073 22.8916C9.9573 23.3376 10.2113 23.7616 10.6273 23.9296C10.7483 23.9786 10.8753 24.0016 11.0003 24.0016C11.3043 24.0016 11.6003 23.8626 11.7933 23.6116L21.7933 10.6116C22.0253 10.3096 22.0653 9.90164 21.8973 9.55964Z'
      fill='currentColor'
    />
  </React.Fragment>
)
